import { useEffect, useRef, useState } from 'react';
import './floatingButtons.css';

const FloatingButtons = () => {
  const phoneNumber = '+61493519401';
  const whatsappNumber = '61493519401'; // Without + for WhatsApp
  const whatsappMessage = encodeURIComponent('Hi! I would like to inquire about your cleaning services.');
  const containerRef = useRef(null);
  const [overFooter, setOverFooter] = useState(false);

  useEffect(() => {
    const checkOverFooter = () => {
      const footer = document.querySelector('footer') || document.querySelector('.footer');
      const container = containerRef.current;
      if (!footer || !container) return;

      const footerRect = footer.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();

      // Buttons overlap footer when container bottom edge enters footer top
      setOverFooter(containerRect.bottom >= footerRect.top);
    };

    window.addEventListener('scroll', checkOverFooter, { passive: true });
    checkOverFooter();
    return () => window.removeEventListener('scroll', checkOverFooter);
  }, []);

  const handleCallClick = () => {
    if (window.gtag) {
      window.gtag('event', 'click_to_call', {
        event_category: 'Contact',
        event_label: 'Floating Call Button',
        value: 1
      });
    }
  };

  const handleWhatsAppClick = () => {
    if (window.gtag) {
      window.gtag('event', 'whatsapp_click', {
        event_category: 'Contact',
        event_label: 'Floating WhatsApp Button',
        value: 1
      });
    }
  };

  return (
    <div ref={containerRef} className={`floating-buttons${overFooter ? ' over-footer' : ''}`}>
      {/* Call Button */}
      <a
        href={`tel:${phoneNumber}`}
        className="floating-btn floating-call"
        aria-label="Call Niks Elite Cleaning"
        onClick={handleCallClick}
      >
        <i className="fas fa-phone"></i>
      </a>

      {/* WhatsApp Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="floating-btn floating-whatsapp"
        aria-label="Chat on WhatsApp"
        onClick={handleWhatsAppClick}
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;
